import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { MailTemplateVisualEditorOptionsSection } from "./mailTemplateVisualEditorOptionsSection";
import { MailTemplateVisualEditorNumberPicker } from "./mailTemplateVisualEditorNumberPicker";

type Props = {
    height: number,
    onChangeHeight: (height: number) => void,
}

export function MailTemplateVisualEditorHeightOption(props: Props): JSX.Element {
    const { t } = useTranslation();
    return (
        <MailTemplateVisualEditorOptionsSection>
            <Typography>{t<string>('shared.mail-template-visual-editor-height')}</Typography>
            <MailTemplateVisualEditorNumberPicker
                measureUnit="px"
                value={props.height}
                onChange={props.onChangeHeight}
            />
        </MailTemplateVisualEditorOptionsSection>
    );
}
